// extracted by mini-css-extract-plugin
export default {"card":"styles_card__SDBz6","card_title":"styles_card_title__C44+3","card_devices":"styles_card_devices__3ycoq"};